import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, normalizeClass as _normalizeClass, Transition as _Transition, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 1,
  class: "controls"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Mask = _resolveComponent("Mask")
  const _component_Segment = _resolveComponent("Segment")

  return (_ctx.mounted)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_openBlock(), _createBlock(_Teleport, { to: $props.maskTo }, [
          _createVNode(_component_Mask, {
            show: $data.show,
            blur: $props.blur
          }, null, 8 /* PROPS */, ["show", "blur"])
        ], 8 /* PROPS */, ["to"])),
        (_openBlock(), _createBlock(_Teleport, { to: $props.modalTo }, [
          _createVNode(_Transition, {
            duration: 200,
            onAfterLeave: _cache[2] || (_cache[2] = $event => (_ctx.$emit('after-leave'))),
            onAfterEnter: _cache[3] || (_cache[3] = $event => (_ctx.$emit('after-enter')))
          }, {
            default: _withCtx(() => [
              ($data.show)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["modal-dialog", {[$props.dialogClass]: true}]),
                    onMousedown: _cache[1] || (_cache[1] = $event => ($data.show && _ctx.$emit('click-outside')))
                  }, [
                    _createVNode(_component_Segment, _mergeProps({[$props.segment]: true}, {
                      class: "modal-content",
                      style: $options.content_style,
                      onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                    }), {
                      default: _withCtx(() => [
                        (_ctx.$slots.header)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                              _createElementVNode("div", _hoisted_2, [
                                _renderSlot(_ctx.$slots, "header")
                              ])
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_3, [
                          _renderSlot(_ctx.$slots, "content")
                        ]),
                        (_ctx.$slots.controls)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              ($props.centered)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                                : _createCommentVNode("v-if", true),
                              _renderSlot(_ctx.$slots, "controls"),
                              ($props.centered)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                                : _createCommentVNode("v-if", true)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 3 /* FORWARDED */
                    }, 16 /* FULL_PROPS */, ["style"])
                  ], 34 /* CLASS, NEED_HYDRATION */))
                : _createCommentVNode("v-if", true)
            ]),
            _: 3 /* FORWARDED */
          })
        ], 8 /* PROPS */, ["to"]))
      ], 64 /* STABLE_FRAGMENT */))
    : _createCommentVNode("v-if", true)
}